import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

if (process.env.NODE_ENV === "development") {
  const resizeObserverError = (e) => {
    if (
      e.message === "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded"
    ) {
      const overlay = document.getElementById("webpack-dev-server-client-overlay");
      if (overlay) {
        overlay.style.display = "none";
      }
    }
  };

  window.addEventListener("error", resizeObserverError);
}

root.render(<App />);